
import { Loader, NewCustomer } from '.';
import React, { useState, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { Party, SUPPORT_MOBILE_NUMBER, User } from 'service';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store/store';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCopy, faCreditCard, faMoneyBill, faPhone, faReceipt, faShoppingCart, faUsers } from '@fortawesome/free-solid-svg-icons';
import ArthaGateway from 'service/ArthaGateway';
import { app_version, clearCache } from 'service/Utils';
import toast from 'react-hot-toast';
import { link } from 'fs';
import { ActionCreators } from 'store/actionCreators';

export const SearchCustomer = ({ onCustomerSelected, allowNewCustomerCreation = false }) => {
    const userData = useSelector((state: RootState) => state.appdata);
    const [user, setUser] = useState<User>();
    const [customers, setCustomers] = useState<Party[]>([]);
    const [showNewCustomer, setShowNewCustomer] = useState(false);
    const [customerName, setCustomerName] = useState<string>('');
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleSearchCustomer = (e: any) => {
        if (e.target.value.length < 3) {
            setCustomers([]);
            return;
        }
        searchCustomer(e.target.value);
    }

    const searchCustomer = (name: string) => {
        setCustomers([]);
        setCustomerName(name);
        ArthaGateway.getCustomers(name).then((response) => {
            console.log(response);
            setCustomers(response.entries);
        }).catch((error) => {
            toast.error("Error fetching party details");
            console.log(error);
        });
    }

    const selectCustomer = (customer: Party) => {
        if(onCustomerSelected) {
            onCustomerSelected(customer);
        }
    }

    const handleCreateNewCustomer = () => {
        setShowNewCustomer(true);
    };

    const handleCloseNewCustomer = () => {
        setShowNewCustomer(false);
    };

    const handleNewCustomerAdded = (newCustomerName) => {
        setShowNewCustomer(false);
        searchCustomer(newCustomerName);
        toast.success("Customer added successfully");
    };

    return (
        <>
            <div className="row" style={{ margin: "20px 0" }}>
                <div className="col-md-12" style={{ textAlign: "center", padding: 0 }}>
                    <input type="text" className="form-control" placeholder='Search customer...' onChange={(e) => handleSearchCustomer(e)} autoFocus />
                </div>
            </div>
            {customers.length > 0 &&
                <div className="row">
                    <table className="table table-striped products-table">
                        <tbody>
                            {customers.map((customer, index) => (
                                <tr key={index}>
                                    <td className='p-2'>
                                        <b>{customer.name} </b><br />
                                        {(customer.mobileNumber)}
                                        <div className="btn btn-dark btn-sm float-end" style={{ marginLeft: "0.25rem" }} onClick={() => selectCustomer(customer)}>Select</div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            }
            {customers.length === 0 && allowNewCustomerCreation == true &&
                <div className='row'>
                    <div className="col-md-12">
                        <div className="btn bg-dark text-white btn-sm w-100" onClick={handleCreateNewCustomer}>Create New Customer</div>
                    </div>
                </div>
            }

            {showNewCustomer && (
                <NewCustomer
                    name={customerName}
                    onCustomerAdded={handleNewCustomerAdded}
                    onClose={handleCloseNewCustomer}
                />
            )}
        </>
    )
}